const MOBILE_BREAKPOINT = 989;
const DEFAULT_MIN_SCALE = 1;
const DEFAULT_MAX_SCALE = 3.2;
const DEFAULT_MOBILE_MIN_SCALE = 0.25;
const DEFAULT_MOBILE_MAX_SCALE = 10;
const MAP_SELECTOR = "interactive-map-component.interactive-map-block";

function normalizeScale(value, fallback) {
  return Number.isFinite(value) && value > 0 ? value : fallback;
}

function syncMapScaleBounds(mapElement) {
  if (!(mapElement instanceof HTMLElement)) return;

  const desktopMinScale = normalizeScale(
    Number(mapElement.dataset.desktopMinScale ?? mapElement.dataset.minScale),
    DEFAULT_MIN_SCALE,
  );
  const mobileMinScale = normalizeScale(
    Number(mapElement.dataset.mobileMinScale),
    DEFAULT_MOBILE_MIN_SCALE,
  );
  const desktopMaxScale = normalizeScale(
    Number(mapElement.dataset.desktopMaxScale ?? mapElement.dataset.maxScale),
    DEFAULT_MAX_SCALE,
  );
  const mobileMaxScale = normalizeScale(
    Number(mapElement.dataset.mobileMaxScale),
    DEFAULT_MOBILE_MAX_SCALE,
  );

  mapElement.dataset.desktopMinScale = String(desktopMinScale);
  mapElement.dataset.desktopMaxScale = String(desktopMaxScale);

  if (window.innerWidth <= MOBILE_BREAKPOINT) {
    mapElement.dataset.minScale = String(
      Math.min(desktopMinScale, mobileMinScale),
    );
    mapElement.dataset.maxScale = String(
      Math.max(desktopMaxScale, mobileMaxScale),
    );
    return;
  }

  mapElement.dataset.minScale = String(desktopMinScale);
  mapElement.dataset.maxScale = String(desktopMaxScale);
}

function syncAllMapScaleBounds() {
  document.querySelectorAll(MAP_SELECTOR).forEach(syncMapScaleBounds);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", syncAllMapScaleBounds, {
    once: true,
  });
} else {
  syncAllMapScaleBounds();
}

window.addEventListener("resize", syncAllMapScaleBounds, { passive: true });
